import { r as zt, c as l, h as r, H as kt, g as At, o as u } from "./main-bb89b2f2.js";
import { D as n } from "./luxon-88c249ba-ecb6bfbf.js";
import { s as o, a as h, f as i, i as Jt, b as Wt } from "./range-util-748d6b40-19039d16.js";
import { T as Yt } from "./translation-service-06f7c8c7-b6396601.js";
import "vue";
const p = "Von", b = "Bis", g = "tt.mm.jjjj", S = "Anwenden", m = "Abbrechen", I = "Ungültiges Datum ausgewählt", Nt = {
  startLabel: p,
  endLabel: b,
  dateInputPlaceholder: g,
  applyButtonLabel: S,
  cancelButtonLabel: m,
  calendarInputInvalidErrorMessage: I
}, Ft = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: p,
  endLabel: b,
  dateInputPlaceholder: g,
  applyButtonLabel: S,
  cancelButtonLabel: m,
  calendarInputInvalidErrorMessage: I,
  default: Nt
}), f = "From", L = "To", y = "dd/mm/yyyy", O = "Apply", j = "Cancel", D = "Invalid Date Selected", Ht = {
  startLabel: f,
  endLabel: L,
  dateInputPlaceholder: y,
  applyButtonLabel: O,
  cancelButtonLabel: j,
  calendarInputInvalidErrorMessage: D
}, qt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: f,
  endLabel: L,
  dateInputPlaceholder: y,
  applyButtonLabel: O,
  cancelButtonLabel: j,
  calendarInputInvalidErrorMessage: D,
  default: Ht
}), v = "Desde", C = "Al", M = "dd/mm/aaaa", P = "Confirmar", E = "Cancelar", B = "Fecha inválida seleccionada", Ut = {
  startLabel: v,
  endLabel: C,
  dateInputPlaceholder: M,
  applyButtonLabel: P,
  cancelButtonLabel: E,
  calendarInputInvalidErrorMessage: B
}, Gt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: v,
  endLabel: C,
  dateInputPlaceholder: M,
  applyButtonLabel: P,
  cancelButtonLabel: E,
  calendarInputInvalidErrorMessage: B,
  default: Ut
}), _ = "De", $ = "À", x = "jj.mm.aaaa", R = "Confirmer", V = "Annuler", w = "Date invalide sélectionnée", Kt = {
  startLabel: _,
  endLabel: $,
  dateInputPlaceholder: x,
  applyButtonLabel: R,
  cancelButtonLabel: V,
  calendarInputInvalidErrorMessage: w
}, Qt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: _,
  endLabel: $,
  dateInputPlaceholder: x,
  applyButtonLabel: R,
  cancelButtonLabel: V,
  calendarInputInvalidErrorMessage: w,
  default: Kt
}), T = "Dal", z = "Al", k = "gg/mm/aaaa", A = "Confermare", J = "Annullare", W = "Data non valida selezionata", Xt = {
  startLabel: T,
  endLabel: z,
  dateInputPlaceholder: k,
  applyButtonLabel: A,
  cancelButtonLabel: J,
  calendarInputInvalidErrorMessage: W
}, Zt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: T,
  endLabel: z,
  dateInputPlaceholder: k,
  applyButtonLabel: A,
  cancelButtonLabel: J,
  calendarInputInvalidErrorMessage: W,
  default: Xt
}), Y = "からだ", N = "それまではね", F = "yyyy/mm/dd", H = "確認", q = "キャンセル", U = "無効な日付が選択されました", te = {
  startLabel: Y,
  endLabel: N,
  dateInputPlaceholder: F,
  applyButtonLabel: H,
  cancelButtonLabel: q,
  calendarInputInvalidErrorMessage: U
}, ee = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: Y,
  endLabel: N,
  dateInputPlaceholder: F,
  applyButtonLabel: H,
  cancelButtonLabel: q,
  calendarInputInvalidErrorMessage: U,
  default: te
}), G = "에서", K = "까지", Q = "yyyy. mm. dd", X = "확인", Z = "취소", tt = "잘못된 날짜가 선택되었습니다", ae = {
  startLabel: G,
  endLabel: K,
  dateInputPlaceholder: Q,
  applyButtonLabel: X,
  cancelButtonLabel: Z,
  calendarInputInvalidErrorMessage: tt
}, ne = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: G,
  endLabel: K,
  dateInputPlaceholder: Q,
  applyButtonLabel: X,
  cancelButtonLabel: Z,
  calendarInputInvalidErrorMessage: tt,
  default: ae
}), et = "Van", at = "Tot", nt = "tt-mm-jjjj", st = "Bevestigen", lt = "Staken", it = "Ongeldige datum geselecteerd", se = {
  startLabel: et,
  endLabel: at,
  dateInputPlaceholder: nt,
  applyButtonLabel: st,
  cancelButtonLabel: lt,
  calendarInputInvalidErrorMessage: it
}, le = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: et,
  endLabel: at,
  dateInputPlaceholder: nt,
  applyButtonLabel: st,
  cancelButtonLabel: lt,
  calendarInputInvalidErrorMessage: it,
  default: se
}), rt = "Od", ot = "Do", ct = "dd.mm.rrrr", dt = "potwierdzać", ut = "Anuluj", ht = "Wybrano nieprawidłową datę", ie = {
  startLabel: rt,
  endLabel: ot,
  dateInputPlaceholder: ct,
  applyButtonLabel: dt,
  cancelButtonLabel: ut,
  calendarInputInvalidErrorMessage: ht
}, re = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: rt,
  endLabel: ot,
  dateInputPlaceholder: ct,
  applyButtonLabel: dt,
  cancelButtonLabel: ut,
  calendarInputInvalidErrorMessage: ht,
  default: ie
}), pt = "De", bt = "Até", gt = "dd/mm/aaaa", St = "Aplicar", mt = "Cancelar", It = "Data inválida selecionada", oe = {
  startLabel: pt,
  endLabel: bt,
  dateInputPlaceholder: gt,
  applyButtonLabel: St,
  cancelButtonLabel: mt,
  calendarInputInvalidErrorMessage: It
}, ce = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: pt,
  endLabel: bt,
  dateInputPlaceholder: gt,
  applyButtonLabel: St,
  cancelButtonLabel: mt,
  calendarInputInvalidErrorMessage: It,
  default: oe
}), ft = "С", Lt = "По", yt = "дд.мм.гггг", Ot = "Применить", jt = "Отмена", Dt = "Выбрана недопустимая дата", de = {
  startLabel: ft,
  endLabel: Lt,
  dateInputPlaceholder: yt,
  applyButtonLabel: Ot,
  cancelButtonLabel: jt,
  calendarInputInvalidErrorMessage: Dt
}, ue = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: ft,
  endLabel: Lt,
  dateInputPlaceholder: yt,
  applyButtonLabel: Ot,
  cancelButtonLabel: jt,
  calendarInputInvalidErrorMessage: Dt,
  default: de
}), vt = "Başlangıç", Ct = "Bitiş", Mt = "gg.aa.yyyy", Pt = "Uygula", Et = "İptal", Bt = "Geçersiz tarih seçildi", he = {
  startLabel: vt,
  endLabel: Ct,
  dateInputPlaceholder: Mt,
  applyButtonLabel: Pt,
  cancelButtonLabel: Et,
  calendarInputInvalidErrorMessage: Bt
}, pe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: vt,
  endLabel: Ct,
  dateInputPlaceholder: Mt,
  applyButtonLabel: Pt,
  cancelButtonLabel: Et,
  calendarInputInvalidErrorMessage: Bt,
  default: he
}), _t = "开始日期", $t = "结束日期", xt = "yyyy/mm/dd", Rt = "应用", Vt = "取消", wt = "选择的日期无效", be = {
  startLabel: _t,
  endLabel: $t,
  dateInputPlaceholder: xt,
  applyButtonLabel: Rt,
  cancelButtonLabel: Vt,
  calendarInputInvalidErrorMessage: wt
}, ge = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  startLabel: _t,
  endLabel: $t,
  dateInputPlaceholder: xt,
  applyButtonLabel: Rt,
  cancelButtonLabel: Vt,
  calendarInputInvalidErrorMessage: wt,
  default: be
}), Se = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}:host{display:block}.static{position:static}.mt-\\[8px\\]{margin-top:8px}.flex{display:flex}.items-center{align-items:center}.visible{visibility:visible}.invisible{visibility:hidden}.right-4{right:var(--spacing-4)}.right-\\[80px\\]{right:80px}.select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.gap-4{gap:var(--spacing-4)}.\\!pr-\\[42px\\]{padding-right:42px!important}.\\!pr-\\[84px\\]{padding-right:84px!important}.blur{--tw-blur:blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.inline-block{display:inline-block}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.p-0{padding:var(--spacing-0)}.px-0{padding-left:var(--spacing-0);padding-right:var(--spacing-0)}.pr-4{padding-right:var(--spacing-4)}.pl-4{padding-left:var(--spacing-4)}.pl-5{padding-left:var(--spacing-5)}.text-left{text-align:left}.text-center{text-align:center}", me = Se, Ie = {
  de: Ft,
  en: qt,
  es: Gt,
  fr: Qt,
  it: Zt,
  ja: ee,
  pt: ce,
  ru: ue,
  zh: ge,
  ko: ne,
  nl: le,
  pl: re,
  tr: pe
}, fe = class {
  constructor(t) {
    zt(this, t), this.lhDateRangeSelectionStart = l(this, "lhDateRangeSelectionStart", 7), this.lhDateRangeSelectionEnd = l(this, "lhDateRangeSelectionEnd", 7), this.lhDateRangeClear = l(this, "lhDateRangeClear", 7), this.lhDateRangeOpen = l(this, "lhDateRangeOpen", 7), this.lhDateRangeClose = l(this, "lhDateRangeClose", 7), this.lhChange = l(this, "lhChange", 7), this.SEPARATOR = "##", this.supportedLangs = ["de", "en", "es", "fr", "it", "ja", "ko", "nl", "pl", "pt", "ru", "tr", "zh"], this.internalState = {
      value: { startDate: null, endDate: null },
      // represents the Prop() value in the internal state as Date objects
      selection: { startDate: null, endDate: null },
      isCalendarOpen: !1,
      isSelectionValid: !1,
      locale: "en",
      // fallback to lang attr
      debug: !1,
      displayedMonth: null,
      yearRange: { past: 5, future: 5 },
      i18n: {},
      maximum: null,
      minimum: null,
      calendarInputStatus: { start: "default", end: "default" },
      calendarInputValue: { start: "", end: "" },
      inputState: { start: { slotted: !1 }, end: { slotted: !1 } },
      calendarYearSelectOptions: [],
      customizableTextInputProps: {}
    }, this.controlled = !1, this.value = void 0, this.yearRangePast = 5, this.yearRangeFuture = 5, this.additionalInfo = "", this.additionalInfoPosition = "top", this.disabled = !1, this.errorText = "", this.infoText = "", this.label = "", this.readonly = !1, this.size = "L", this.status = "default", this.successText = "", this.warningText = "", this.usePlaceholderHeight = !1, this.wcag = "AAA", this.minimum = void 0, this.maximum = void 0, this.displayedMonth = "", this.lastClickWasStartDate = !0;
  }
  /**
   * Method to get the internal state of the component. This is useful for
   * debugging and unit tests. Do not use this for other purposes.
   */
  async getInternalState() {
    return Promise.resolve(this.internalState);
  }
  handleEscapePress(t) {
    t.key === "Escape" && (this.closeCalendar(), this.lhDateRangeClose.emit());
  }
  // Watchers
  handleCustomizableTextInputPropsChange(t, e, a) {
    this.updateCustomizableProps({ [a]: t });
  }
  // Utility to update customizableTextInputProps in internalState
  updateCustomizableProps(t) {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { customizableTextInputProps: Object.assign(Object.assign({}, this.internalState.customizableTextInputProps), t) });
  }
  valueWatcher(t, e) {
    this.handleValueChange(t);
  }
  datepickerRangeStateWatcher(t, e) {
    t.debug && console.log("Old State", e, "New State", t);
  }
  yearRangePastWatcher(t) {
    const e = Object.assign(Object.assign({}, this.internalState.yearRange), { past: t });
    this.internalState = Object.assign(Object.assign({}, this.internalState), { yearRange: e });
  }
  yearRangeFutureWatcher(t) {
    const e = Object.assign(Object.assign({}, this.internalState.yearRange), { future: t });
    this.internalState = Object.assign(Object.assign({}, this.internalState), { yearRange: e });
  }
  displayedMonthWatcher(t) {
    const e = n.fromISO(t);
    e.isValid ? this.updateDisplayedMonthState(e) : console.warn("Could not create date from provided value for displayedMonth. Did you remember to provide a date formatted by .toISOString()?");
  }
  handle(t) {
    const e = t.detail;
    this.debugEvent("controller received __lhInternalDateRangeInputClear", t.detail), e === "start" && this.handleStartClear(), e === "end" && this.handleEndClear();
  }
  handleInputChange(t) {
    this.debugEvent("controller received lhDateRangeInputValueChanged:", t.detail), t.stopImmediatePropagation(), this.updateInputValue(t.detail), t.detail.inputValue === null ? this.handleDeleteInput(t.detail.name) : this.isOutsideMinMax(t.detail.inputValue) ? this.updateInputStatus(t.detail.name, "error") : this.handleDateInput(t);
  }
  handleClear(t) {
    this.debugEvent("controller received lhDateRangeClear"), t.stopImmediatePropagation(), this.lhDateRangeClear.emit(), this.controlled || (this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: { startDate: null, endDate: null } }), this.value = ""), this.updateSelectionValidity();
  }
  handleCancel(t) {
    t.stopImmediatePropagation(), this.debugEvent("controller received lhDateRangeCancelSelection"), this.closeCalendar(), this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: Object.assign({}, this.internalState.value) }), this.updateSelectionValidity(), this.internalState = Object.assign(Object.assign({}, this.internalState), { calendarInputStatus: { start: "default", end: "default" }, calendarInputValue: { start: "", end: "" } });
  }
  handleApply(t) {
    t.stopImmediatePropagation(), this.debugEvent("controller received lhDateRangeApplySelection"), this.closeCalendar(), this.controlled || (this.value = this.formatRangeAsString(this.internalState.selection)), this.lhChange.emit(this.internalState.selection), this.debugEvent("controller emitted lhChange", this.internalState.selection);
  }
  handleDayClick(t) {
    t.stopImmediatePropagation(), this.debugEvent("controller received lhDateRangeDayClick:", t.detail);
    const e = t.detail, a = Object.assign({}, this.internalState.selection);
    if (!a.startDate || !this.lastClickWasStartDate) {
      a.startDate = o(e), a.endDate = null, this.lastClickWasStartDate = !0;
      const s = o(e);
      this.lhDateRangeSelectionStart.emit(s), this.debugEvent("controller emitted lhSelectionStart");
    } else if (e > a.startDate) {
      const s = h(e);
      a.endDate = s, this.lastClickWasStartDate = !1, this.lhDateRangeSelectionEnd.emit(s), this.debugEvent("controller emitted lhSelectionEnd:", e);
    } else if (this.isSameDay(e, a.startDate))
      a.endDate = e;
    else {
      const s = o(e);
      a.startDate = s, a.endDate = null, this.lastClickWasStartDate = !0, this.lhDateRangeSelectionStart.emit(s), this.debugEvent("controller emitted lhSelectionStart:", e);
    }
    this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: a, calendarInputValue: {
      start: i(a.startDate, this.internalState.locale),
      end: i(a.endDate, this.internalState.locale)
    } }), this.updateSelectionValidity();
  }
  handleMonthChange(t) {
    t.stopImmediatePropagation(), this.debugEvent("controller received lhDateRangeDisplayedMonthChange:", t.detail);
    const { month: e, year: a } = t.detail, s = n.local().setLocale(this.internalState.locale).set({ month: e, year: a }).toJSDate();
    this.internalState = Object.assign(Object.assign({}, this.internalState), { displayedMonth: s });
    const c = this.generateYearOptions(s);
    this.internalState = Object.assign(Object.assign({}, this.internalState), { displayedMonth: s, calendarYearSelectOptions: c });
  }
  handleDateRangeClose(t) {
    t.stopImmediatePropagation(), this.debugEvent("controller received __lhInternalDateRangeClose"), this.closeCalendar(), this.setupDisplayedMonth(), this.lhDateRangeClose.emit();
  }
  handleCalendarShow(t) {
    t.stopImmediatePropagation(), this.debugEvent("controller received __lhInternalDateRangeOpen"), this.setCurrentValueAsSelection(), this.setSelectionAsInputValues(), this.setMonthToOpenCalendarAt(), this.setupYearOptions(), this.openCalendar(), this.lhDateRangeOpen.emit();
  }
  handlePreviousMonthClick(t) {
    t.stopImmediatePropagation(), this.debugEvent("controller received __lhInternalDateRangePreviousMonthClick");
    const e = n.fromJSDate(this.internalState.displayedMonth).minus({ months: 1 }).toJSDate();
    this.internalState = Object.assign(Object.assign({}, this.internalState), { displayedMonth: e });
  }
  handleNextMonthClick(t) {
    t.stopImmediatePropagation(), this.debugEvent("controller received __lhInternalDateRangeNextMonthClick");
    const e = n.fromJSDate(this.internalState.displayedMonth).plus({ months: 1 }).toJSDate();
    this.internalState = Object.assign(Object.assign({}, this.internalState), { displayedMonth: e });
  }
  connectedCallback() {
    this.setupLocale(), this.setupValue(), this.setupYearRange(), this.setupCustomizableInputProps(), this.setupMinMax(), this.setupDisplayedMonth();
  }
  componentWillLoad() {
    this.wcag === "AAA" && (this.size = "L");
  }
  componentDidLoad() {
    this.detectSlottedContent();
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  render() {
    return r(kt, { key: "c68be3c3d19cefe57e39cdf0d14e778bd981439a", "data-testid": "datepicker-range" }, r("patternlib-datepicker-range-view", { key: "c81a58e28d611e59f4f140fac6e7ebebb9ba3469", "data-testid": "range-view", state: this.internalState }, r("slot", { key: "a2e29a5ae7d1bd2b993cc61360a7e02f387bd09b", onSlotchange: this.handleInputStartSlotChange.bind(this), name: "calendar-input-start", slot: "calendar-input-start" }), r("slot", { key: "00394a8ddaaad3f0c1aa23736e4edbaccce70b37", onSlotchange: this.handleInputEndSlotChange.bind(this), name: "calendar-input-end", slot: "calendar-input-end" })));
  }
  updateSelection(t) {
    const { inputValue: e, name: a } = t.detail;
    a === "start" ? (this.updateSelectionStart(e), e > this.internalState.selection.endDate && this.resetSelectionEnd()) : a === "end" && (this.updateSelectionEnd(e), e < this.internalState.selection.startDate && this.resetSelectionEnd());
  }
  updateSelectionStart(t) {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: Object.assign(Object.assign({}, this.internalState.selection), { startDate: t }) });
  }
  updateSelectionEnd(t) {
    const e = h(t);
    this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: Object.assign(Object.assign({}, this.internalState.selection), { endDate: e }) });
  }
  closeCalendar() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { isCalendarOpen: !1 });
  }
  openCalendar() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { isCalendarOpen: !0 });
  }
  isValueEmpty(t) {
    return t === "";
  }
  clearRangeState() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { value: { startDate: null, endDate: null }, selection: { startDate: null, endDate: null } });
  }
  updateValue(t) {
    const [e, a] = this.parseValue(t);
    this.internalState = Object.assign(Object.assign({}, this.internalState), { value: { startDate: e, endDate: a } });
  }
  /** Parses the start and end dates from the value string using the custom separator */
  parseValue(t) {
    return t.split(this.SEPARATOR).map((e) => new Date(e));
  }
  formatRangeAsString(t) {
    const e = (a) => a ? n.fromJSDate(a).toISO() : "";
    return `${e(t.startDate)}${this.SEPARATOR}${e(t.endDate)}`;
  }
  // Validation logic
  getSelectionValidity() {
    const t = this.internalState.selection, e = t.startDate !== null && t.endDate !== null;
    return e && t.startDate <= t.endDate;
  }
  debugEvent(t, e) {
    this.internalState.debug && console.debug(t, e);
  }
  setupLocale() {
    const t = document.documentElement.getAttribute("lang") || "en";
    this.updateI18NState(t);
    const e = (a) => {
      this.internalState = Object.assign(Object.assign({}, this.internalState), { locale: u("lang", a) || t }), this.updateI18NState(u("lang", a) || t);
    };
    this.observer = new MutationObserver(e), this.observer.observe(document.documentElement, { attributes: !0 });
  }
  setupValue() {
    this.value && (this.updateValue(this.value), this.updateSelectionValidity());
  }
  updateI18NState(t) {
    const e = this.supportedLangs.includes(t) ? t : "en";
    this.internalState = Object.assign(Object.assign({}, this.internalState), { locale: e });
    const a = Yt.resolveJsonBasedOnLanguage(e, Ie);
    this.internalState = Object.assign(Object.assign({}, this.internalState), { i18n: a });
  }
  handleValueChange(t) {
    this.isValueEmpty(t) ? this.clearRangeState() : (this.updateValue(t), this.updateSelectionValidity());
  }
  updateSelectionValidity() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { isSelectionValid: this.getSelectionValidity() });
  }
  setCurrentValueAsSelection() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: Object.assign({}, this.internalState.value) });
  }
  setupYearRange() {
    let t = { past: 5, future: 5 };
    typeof this.yearRangeFuture == "number" && (t.past = this.yearRangePast), typeof this.yearRangeFuture == "number" && (t.future = this.yearRangeFuture), this.internalState = Object.assign(Object.assign({}, this.internalState), { yearRange: t });
  }
  setupCustomizableInputProps() {
    this.internalState.customizableTextInputProps = Object.assign(Object.assign({}, this.internalState.customizableTextInputProps), { additionalInfo: this.additionalInfo, additionalInfoPosition: this.additionalInfoPosition, disabled: this.disabled, errorText: this.errorText, infoText: this.infoText, label: this.label, readonly: this.readonly, size: this.size, status: this.status, successText: this.successText, usePlaceholderHeight: this.usePlaceholderHeight, warningText: this.warningText, wcag: this.wcag });
  }
  setupMinMax() {
    this.setupMinimum(), this.setupMaximum();
  }
  setupDisplayedMonth() {
    if (this.displayedMonth !== "") {
      const t = n.fromISO(this.displayedMonth);
      t.isValid ? this.updateDisplayedMonthState(t) : console.warn("Could not create date from provided value for displayedMonth. Did you remember to provide a date formatted with Date.prototype.toISOString()?");
    }
  }
  setupMinimum() {
    n.fromISO(this.minimum).isValid && (this.internalState.minimum = new Date(this.minimum));
  }
  setupMaximum() {
    n.fromISO(this.maximum).isValid && (this.internalState.maximum = new Date(this.maximum));
  }
  updateDisplayedMonthState(t) {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { displayedMonth: t.toJSDate() });
  }
  isOutsideMinMax(t) {
    let e = !1, a = !1;
    return this.minimum && (e = Jt(n.fromJSDate(t), n.fromISO(this.minimum))), this.maximum && (a = Wt(n.fromJSDate(t), n.fromISO(this.maximum))), e || a;
  }
  updateInputStatus(t, e) {
    t === "start" && (this.internalState = Object.assign(Object.assign({}, this.internalState), { calendarInputStatus: Object.assign(Object.assign({}, this.internalState.calendarInputStatus), { start: e }) })), t === "end" && (this.internalState = Object.assign(Object.assign({}, this.internalState), { calendarInputStatus: Object.assign(Object.assign({}, this.internalState.calendarInputStatus), { end: e }) }));
  }
  updateInputValue(t) {
    const e = i(t.inputValue);
    t.name === "start" && (this.internalState = Object.assign(Object.assign({}, this.internalState), { calendarInputValue: Object.assign(Object.assign({}, this.internalState.calendarInputValue), { start: e }) })), t.name === "end" && (this.internalState = Object.assign(Object.assign({}, this.internalState), { calendarInputValue: Object.assign(Object.assign({}, this.internalState.calendarInputValue), { end: e }) }));
  }
  handleDeleteInput(t) {
    t === "start" && this.resetSelectionStart(), t === "end" && this.resetSelectionEnd(), this.updateSelectionValidity();
  }
  resetSelectionStart() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: Object.assign(Object.assign({}, this.internalState.selection), { startDate: null }) });
  }
  resetSelectionEnd() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { selection: Object.assign(Object.assign({}, this.internalState.selection), { endDate: null }) });
  }
  /*
   * "valid" means that the payload of the emitted input element is not null
   * AND the date is not outside minimum or maximum if specified
   */
  handleDateInput(t) {
    this.updateSelection(t), this.updateSelectionValidity(), this.updateInputStatus(t.detail.name, "default"), this.updateDisplayedMonthState(n.fromJSDate(t.detail.inputValue));
  }
  isSameDay(t, e) {
    return n.fromJSDate(t).hasSame(n.fromJSDate(e), "day");
  }
  handleStartClear() {
    const t = {
      selection: { endDate: null, startDate: null },
      calendarInputValue: { start: "", end: "" },
      isSelectionValid: !1
    };
    this.internalState = Object.assign(Object.assign({}, this.internalState), t);
  }
  handleEndClear() {
    const t = {
      selection: Object.assign(Object.assign({}, this.internalState.selection), { endDate: null }),
      calendarInputValue: Object.assign(Object.assign({}, this.internalState.calendarInputValue), { end: "" }),
      isSelectionValid: !1
    };
    this.lastClickWasStartDate = !0, this.internalState = Object.assign(Object.assign({}, this.internalState), t);
  }
  // generateYearOptions now reads from this.state.yearRange
  generateYearOptions(t) {
    const e = n.fromJSDate(t).year, a = e - this.internalState.yearRange.past, s = e + this.internalState.yearRange.future;
    return Array.from({ length: s - a + 1 }, (c, Tt) => {
      const d = a + Tt;
      return { value: d, label: d.toString() };
    });
  }
  setupYearOptions() {
    const t = this.generateYearOptions(this.internalState.displayedMonth);
    this.internalState = Object.assign(Object.assign({}, this.internalState), { calendarYearSelectOptions: t });
  }
  setSelectionAsInputValues() {
    this.internalState = Object.assign(Object.assign({}, this.internalState), { calendarInputValue: {
      start: i(this.internalState.selection.startDate),
      end: i(this.internalState.selection.endDate)
    } });
  }
  setMonthToOpenCalendarAt() {
    if (this.displayedMonth === "")
      if (this.internalState.selection.startDate) {
        const t = this.internalState.selection.startDate;
        this.updateDisplayedMonthState(n.fromJSDate(t));
      } else
        this.updateDisplayedMonthState(n.now().setLocale(this.internalState.locale));
  }
  handleInputStartSlotChange() {
    this.updateSlottedInputStartState();
  }
  updateSlottedInputStartState() {
    const t = this.hostElement.shadowRoot.querySelector('slot[name="calendar-input-start"]'), a = (t == null ? void 0 : t.assignedNodes()).length > 0, s = {
      inputState: Object.assign(Object.assign({}, this.internalState.inputState), { start: {
        slotted: a
      } })
    };
    this.internalState = Object.assign(Object.assign({}, this.internalState), s);
  }
  handleInputEndSlotChange() {
    this.updateSlottedInputEndState();
  }
  updateSlottedInputEndState() {
    const t = this.hostElement.shadowRoot.querySelector('slot[name="calendar-input-end"]'), a = (t == null ? void 0 : t.assignedNodes()).length > 0, s = {
      inputState: Object.assign(Object.assign({}, this.internalState.inputState), { end: {
        slotted: a
      } })
    };
    this.internalState = Object.assign(Object.assign({}, this.internalState), s);
  }
  detectSlottedContent() {
    this.updateSlottedInputStartState(), this.updateSlottedInputEndState();
  }
  get hostElement() {
    return At(this);
  }
  static get watchers() {
    return {
      additionalInfo: ["handleCustomizableTextInputPropsChange"],
      additionalInfoPosition: ["handleCustomizableTextInputPropsChange"],
      disabled: ["handleCustomizableTextInputPropsChange"],
      errorText: ["handleCustomizableTextInputPropsChange"],
      infoText: ["handleCustomizableTextInputPropsChange"],
      label: ["handleCustomizableTextInputPropsChange"],
      readonly: ["handleCustomizableTextInputPropsChange"],
      size: ["handleCustomizableTextInputPropsChange"],
      status: ["handleCustomizableTextInputPropsChange"],
      successText: ["handleCustomizableTextInputPropsChange"],
      warningText: ["handleCustomizableTextInputPropsChange"],
      usePlaceholderHeight: ["handleCustomizableTextInputPropsChange"],
      wcag: ["handleCustomizableTextInputPropsChange"],
      value: ["valueWatcher"],
      datepickerRangeState: ["datepickerRangeStateWatcher"],
      yearRangePast: ["yearRangePastWatcher"],
      yearRangeFuture: ["yearRangeFutureWatcher"],
      displayedMonth: ["displayedMonthWatcher"]
    };
  }
};
fe.style = me;
export {
  fe as patternlib_datepicker_range
};
